import { supabase } from '../../shared/supabase/supabaseClient';
import type { PlanEntitlementsRow } from '../../shell/feature-flags/domain/planEntitlements';
import type { PosFiscalDefaultStrategy } from '../domain/posFiscalDefaults';
import { mergeOfflineAccountSnapshot } from '../../shell/session/offlineAccountCache';

/** Persiste en Supabase y actualiza snapshot offline de entitlements de inmediato. */
export async function persistDefaultPosFiscalMode(params: {
  organizationId: string;
  userId: string;
  mode: PosFiscalDefaultStrategy;
  currentEntitlements: PlanEntitlementsRow | null;
}): Promise<void> {
  const { error } = await supabase
    .from('organizations')
    .update({ default_pos_fiscal_mode: params.mode })
    .eq('id', params.organizationId);
  if (error) throw error;

  if (params.currentEntitlements) {
    await mergeOfflineAccountSnapshot(params.userId, {
      entitlements: {
        ...params.currentEntitlements,
        default_pos_fiscal_mode: params.mode,
      },
    });
  }
}
